module.exports = __webpack_public_path__ + "img/oblako.5de4b5d2.png";